import React from 'react';

interface DateTimeRendererProps {
  value: Date | null;
}

const DateTimeRenderer: React.FC<DateTimeRendererProps> = ({ value }) => {
  if (!value) {
    return <span>-</span>;
  }

  try {
    const date = value instanceof Date ? value : new Date(value);

    // Format: "Sat, 02/28/2026 10:00 PM PST"
    const dayOfWeek = date.toLocaleDateString('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'short',
    });

    const dateStr = date.toLocaleDateString('en-US', {
      timeZone: 'America/Los_Angeles',
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });

    const timeStr = date.toLocaleTimeString('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'short',
    });
    const parts = formatter.formatToParts(date);
    const timeZoneName = parts.find((part) => part.type === 'timeZoneName')?.value || 'PST';

    return <span>{`${dayOfWeek}, ${dateStr} ${timeStr} ${timeZoneName}`}</span>;
  } catch (error) {
    console.error('Error formatting date:', error);
    return <span>Invalid Date</span>;
  }
};

export default DateTimeRenderer;
